export default class linkTooltip {
  constructor(el) {
    document.addEventListener("DOMContentLoaded", () => this.load());
  }

  load = () => {
    const links = document.querySelectorAll('a[href*="/tooltip/"], [data-tooltip]');
    links.forEach((tooltipToggle) => {
      tooltipToggle.addEventListener("click", (e) => {
        e.preventDefault();
        const source = e.currentTarget.tagName === "A" ? "href" : "data-tooltip";
        const url = e.currentTarget.getAttribute(source);

        const productSidebar = document.querySelector(".product__sidebar.product__sidebar--info");
        if (productSidebar.classList.contains("is-expanded")) {
          this.closeTooltip();
        } else {
          this.loadTooltipContent(url, e.currentTarget);
        }
      });
    });

    document.addEventListener("click", (e) => {
      const productSidebar = document.querySelector(".product__sidebar.product__sidebar--info");
      if(e.target.tagName == 'A') {        
        const link = e.target.href.includes("/tooltip/");
        if(link) {
          e.preventDefault();
          this.closeTooltip();
          this.loadTooltipContent(e.target.href, e.target);
        }
      }

      if (
        productSidebar.classList.contains("is-expanded") &&
        !productSidebar.contains(e.target) &&
        !e.target.closest('a[href*="/tooltip/"], [data-tooltip]')
      ) {
        this.closeTooltip();
      }
    });
  };

  loadTooltipContent = async (url, triggerElement) => {
    const productSidebar = document.querySelector(".product__sidebar.product__sidebar--info");
    const tooltipBody = document.querySelector(".product__sidebar__content__body");

    document.body.classList.add("sidebar--is-loading");
    

    try {
      const formData = new FormData();
      formData.append("action", "tooltip");
      formData.append("link", url);

     const response = await fetch(TWZ.ajaxurl, {
      method: "POST",
      body: formData,
    });

      if (!response.ok) throw new Error("Kan inhoud niet laden.");

      const data = await response.json();

      if (!data.success) {
        throw new Error(data.message || "Tooltip niet gevonden.");
      }

      tooltipBody.innerHTML = data.data.tooltip || "";

      this.positionTooltip(triggerElement);
      productSidebar.classList.add("is-expanded");

      document.body.classList.remove("sidebar--is-loading");
    } catch (error) {
      console.error("Fout bij het laden van de tooltip:", error);
      tooltipBody.innerHTML = "Kan tooltip niet laden.";
      document.body.classList.remove("sidebar--is-loading");
    }
  };

  positionTooltip = (triggerElement) => {
    const productSidebar = document.querySelector(".product__sidebar.product__sidebar--info");

    const rect = triggerElement.getBoundingClientRect();
    const top = window.scrollY + rect.bottom + 20;
    const left = window.scrollX + rect.left;

    productSidebar.style.position = "absolute";
    productSidebar.style.top = `${top}px`;
    productSidebar.style.left = `${left}px`;
    productSidebar.style.width = `${rect.width}px`;
  };

  closeTooltip = () => {
    const productSidebar = document.querySelector(".product__sidebar.product__sidebar--info");
    if (productSidebar.classList.contains("is-expanded")) {
      productSidebar.classList.remove("is-expanded");
    }
  };
}

new linkTooltip();
